import useSWR, { SWRConfiguration } from 'swr';
import { customSWRResponse, NewTicket } from '../../model/types';
import useSWRCacheKeys from '../useSWRCacheKeys';

export default function useTicketByKey(ticketKey: string, config: SWRConfiguration = {}): customSWRResponse<NewTicket> {
    const keys = useSWRCacheKeys(ticketKey?.startsWith('TICKET-') ? `/tickets/${ticketKey}?ui=true` : null);

    return useSWR(keys, { ...config });
}
